import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'

import { isAdminRole } from '@/helpers/team'
import { useLeaveTeam, useTeam } from '@/react-query/team'
import { useTeamMembers } from '@/react-query/team-members'

export const LeaveTeamModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) => {
  const leaveTeam = useLeaveTeam()
  const team = useTeam().data
  const teamMembers = useTeamMembers().data

  const numberOfAdmins = teamMembers?.filter((member) =>
    isAdminRole(member.role),
  ).length
  const isOnlyAdmin =
    isAdminRole(team?.userRole) &&
    (teamMembers?.length || 0) > 1 &&
    numberOfAdmins === 1

  const handleLeaveTeam = async () => {
    try {
      await leaveTeam.mutateAsync()
      onClose()
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Leave team</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {!isOnlyAdmin && (
            <Text>
              Are you sure you want to leave the team <b>{team?.name}</b>?
            </Text>
          )}
          <Text fontWeight={'bold'}>
            {isOnlyAdmin &&
              'The only admin cannot leave the team with other members. Please remove other members first or assign admin role to the other team member.'}
          </Text>
        </ModalBody>
        <ModalFooter>
          {!isOnlyAdmin && (
            <Button
              variant={'brand-solid-red'}
              onClick={handleLeaveTeam}
              isLoading={leaveTeam.isPending}
            >
              Leave team
            </Button>
          )}
          <Button variant={'brand-solid-white'} onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
